<script setup lang="ts">
import { computed } from 'vue';
import Order from '@/models/order';
import router from '@/router';
import Point from '@/models/point';
import { setHaptic } from '@/tools/setTelegramHaptick';
import { pluralize } from '@/tools/tools';
import AnimatePlaceHolder from '@/components/mobile/telegram/AnimatePlaceHolder.vue';
import { formatedDateDay } from '@/tools/tools'

const props = defineProps<{ 
  order: Order,
  isLast: boolean,
  isFirst: boolean,
  point?: Point,
  isAdmin: boolean,
  ordersIsResieved?: boolean
}>();

const positionText = computed(() => {
  const count = props.order.products.length;
  return `${count} ${pluralize(count, 'позиция', 'позиции', 'позиций')}`;
});

</script>

<template>
  <div v-if="props.ordersIsResieved === true" class="item" @click="setHaptic(); props.isAdmin == true ? router.push(`/order?id=${props.order.id}&point_id=${props.point?.id}&point_uuid=${props.point?.uuid}&isAdmin=${props.isAdmin}`) : router.push(`/order?id=${props.order.id}&point_id=${props.point?.id}&point_uuid=${props.point?.uuid}`)">
    <div class="absolute-status" :style="{ backgroundColor: props.order.status == 'Доставлен' ? 'var(--green-color)' : 'var(--orange-color)' }"></div>
    <div class="item__up">
      <div class="left-item">
        <div class="icon-item">
          <svg width="40" height="40" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.22841 19.6878C2.98436 22.7193 3.36234 24.235 4.48973 25.1175C5.61712 26 7.17555 26 10.2924 26H16.7075C19.8245 26 21.3829 26 22.5103 25.1175C23.6377 24.235 24.0156 22.7193 24.7716 19.6878C25.9601 14.9214 26.5544 12.5382 25.3065 10.9358C24.0586 9.33333 21.6083 9.33333 16.7075 9.33333H10.2924C5.39182 9.33333 2.94152 9.33333 1.69353 10.9358C0.960966 11.8764 0.863201 13.0861 1.1478 14.8889M23.8896 10.0278L22.9055 6.40924C22.526 5.01396 22.3362 4.31632 21.9471 3.79092C21.5594 3.26768 21.0327 2.86436 20.4273 2.62711C19.8193 2.38889 19.0981 2.38889 17.6555 2.38889M17.6555 2.38889C17.6555 1.62183 17.0353 1 16.2701 1H10.7287C9.96356 1 9.3433 1.62183 9.3433 2.38889M17.6555 2.38889C17.6555 3.15594 17.0353 3.77778 16.2701 3.77778H10.7287C9.96356 3.77778 9.3433 3.15594 9.3433 2.38889M3.10916 10.0278L4.09333 6.40924C4.47281 5.01396 4.66254 4.31632 5.05174 3.79092C5.43933 3.26768 5.96601 2.86436 6.57149 2.62711C7.17947 2.38889 7.90075 2.38889 9.3433 2.38889M19.0409 14.8889V20.4444M7.95794 14.8889V20.4444M13.4994 14.8889V20.4444" 
            :stroke="props.order.status == 'Доставлен' ? 'var(--green-color)' : 'var(--orange-color)'" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="text-item">
          <div class="icon-item">
            <p class="label-item">{{ props.order.id}}</p>
          </div>
          <p class="items-length">
            {{ positionText }}
          </p>
          <p class="items-length">
            Создан: {{ formatedDateDay(props.order.date_create) }}
          </p>
          <p class="status-item">
            {{ props.order.status }}
          </p>
        </div>
      </div>
      <div class="rightn-item">
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.67578 12.1982C1.67578 12.1982 7.1886 7.05294 7.1886 6.68542C7.1886 6.3179 1.67578 1.1726 1.67578 1.1726" stroke="#BAB9BD" stroke-width="2.20513" stroke-linecap="round"/>
        </svg>
      </div>
    </div>

    <div class="item__down" v-if="props.order.comment !== null">
      {{ props.order.comment }}
    </div>
  </div>
  <AnimatePlaceHolder v-else
    width="100%"
    height="162px"
    border-radius="var(--border-radius)"
  />
</template>

<style scoped>

.item__down {
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  border-radius: var(--border-radius-2);
  background-color: var(--grey-color);
  color: black;
  text-align: start;
  padding: 10px 0 10px 20px;
}

.absolute-status {
  position: absolute;
  width: 5px;
  height: 100%;
  top: 0;
  left: 0;
}

.items-length {
  text-align: start;
  font-size: 18px;
}

.item__up {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.status-item{
  font-size: 15px;
  text-align: start;
  color: #8E8E92;
  margin-top: 3px;
}

.label-item{
  font-size: 20px;
  font-weight: 500;
}

.icon-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.text-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.icon-item{
  display: flex;
}

.left-item{
  display: flex;
  align-items: center;
  gap: 16px;
}

.item{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: black;
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  border-radius: var(--border-radius);
  position: relative;
  overflow: hidden;
  box-shadow: var(--drop-shadow-item);
}

</style>
